import Table from 'react-bootstrap/Table'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'

const getStripeAccountScopeLabel = (stripeAccountScope) =>
  stripeAccountScope === 'platform' ? 'Platform' : 'Connected account'

export default function LocationsTable({
  locations,
  terminalConfig,
  handleShowLocationModal,
}) {
  return (
    <>
      {terminalConfig?.destinationAccount ? (
        <Alert key="destination-info" variant="warning" className="mb-3">
          Locations created before this organization switched to destination
          charges may still exist on the connected account. Re-create them here
          so box office payments use the platform account.
        </Alert>
      ) : null}

      <Row className="justify-content-md-end mb-3">
        <Col md="auto">
          <Button variant="primary" onClick={() => handleShowLocationModal()}>
            Add Location
          </Button>
        </Col>
      </Row>
      {locations && locations.length > 0 ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Stripe account</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {locations.map((location) => (
              <tr key={location.location_id}>
                <td>{location?.displayName}</td>
                <td>
                  {getStripeAccountScopeLabel(
                    location?.stripeAccountScope ||
                      terminalConfig?.stripeAccountScope
                  )}
                </td>
                <td onClick={() => handleShowLocationModal(location)}>
                  <Button variant="link">Edit</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Alert variant="light" className="mb-0">
          No locations yet. Add a location before registering readers.
        </Alert>
      )}
    </>
  )
}
